import { useState } from "react";
import { Code2, Plus, Search, X } from "lucide-react";
import type { ProfileSkillItem } from "../../../types/candidateProfile.types";

interface SkillsCardProps {
  skills: ProfileSkillItem[];
  onEdit?: () => void;
  onAdd?: () => void;
  onRemove?: (skillName: string) => void;
}

export default function SkillsCard({ skills, onEdit, onAdd, onRemove }: SkillsCardProps) {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredSkills = skills.filter((skill) => skill.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3"><div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100"><Code2 className="text-blue-600" size={20} /></div><div><h2 className="text-lg font-semibold">Skills</h2><p className="text-sm text-slate-500">Technical Expertise</p></div></div>
        <button type="button" onClick={onAdd || onEdit} className="flex items-center gap-2 rounded-lg bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700"><Plus size={16} />Add</button>
      </div>
      <div className="relative mt-5"><Search size={16} className="absolute left-3 top-3 text-slate-400" /><input value={searchTerm} onChange={(event) => setSearchTerm(event.target.value)} placeholder="Search skills..." className="w-full rounded-lg border border-slate-200 py-2.5 pl-10 pr-4 text-sm outline-none focus:border-blue-500" /></div>
      <div className="mt-5 flex flex-wrap gap-3">
        {filteredSkills.map((skill) => <div key={skill.name} className="flex items-center gap-3 rounded-full border border-slate-200 bg-slate-50 px-4 py-2"><button type="button" onClick={onEdit} className="text-left"><p className="text-sm font-medium">{skill.name}</p><p className="text-xs text-slate-500">{skill.level}</p></button><button type="button" onClick={() => onRemove?.(skill.name)} aria-label={`Remove ${skill.name}`} className="rounded-full p-1"><X size={14} className="text-slate-400 hover:text-red-500" /></button></div>)}
        {filteredSkills.length === 0 && <p className="text-sm text-slate-500">No matching skills.</p>}
      </div>
    </div>
  );
}
